function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useQuery } from "@apollo/client";
import React, { useState } from "react";
import { Chart } from "react-google-charts";
import "./EmployeeTimeline.css";
import moment from "moment-timezone";
import { FilterContext, UserContext } from "../index";
import { USER_TIMELINE_DATA_QUERY, USER_TIMELINE_COUNT_QUERY } from "./query";
import { arrayToStringOutput } from "./../SideMenu/Header";
import Loader from "./../Loader/Loader";
var _require = require("../utils"),
  convertSecToHoursAndMinutesAndSecWithTextShortForm = _require.convertSecToHoursAndMinutesAndSecWithTextShortForm;
import Pagination from "react-bootstrap/Pagination";
var USER_LIMIT = 10;
var EmployeeTimeline = function EmployeeTimeline(props) {
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    focusedRow = _React$useState2[0],
    setFocusedRow = _React$useState2[1];
  var _React$useContext = React.useContext(FilterContext),
    organisationId = _React$useContext.organisationId,
    teamId = _React$useContext.teamId,
    startDate = _React$useContext.startDate,
    endDate = _React$useContext.endDate,
    organisationBilling = _React$useContext.organisationBilling,
    organisationSettings = _React$useContext.organisationSettings,
    role = _React$useContext.role,
    from = _React$useContext.from,
    organisationUserCount = _React$useContext.organisationUserCount,
    organisationStatus = _React$useContext.organisationStatus;
  var _React$useState3 = React.useState(1),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    activeTimeline = _React$useState4[0],
    setActiveTimeline = _React$useState4[1];

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);

  React.useEffect(function () {
    if (from == "web" && role == "Member") {
      props === null || props === void 0 ? void 0 : props.history.push("/my-work");
    }
  }, [role]);
  React.useEffect(function () {
    if (((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped") && role != "Member" || organisationStatus == "inactive") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  var _useQuery = useQuery(USER_TIMELINE_COUNT_QUERY, {
      variables: {
        teamId: teamId,
        organisationId: organisationId,
        startDate: Number(moment(startDate).format("x")),
        endDate: Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("x")),
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        userRole: role
      },
      skip: !organisationId || !teamId
    }),
    userTimelineCountData = _useQuery.data,
    userTimelineCountError = _useQuery.error,
    userTimelineCountLoading = _useQuery.loading,
    userTimelineCountRefetch = _useQuery.refetch;
  var _useQuery2 = useQuery(USER_TIMELINE_DATA_QUERY, {
      variables: {
        teamId: teamId,
        organisationId: organisationId,
        startDate: Number(moment(startDate).format("x")),
        endDate: Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("x")),
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        userRole: role,
        limit: USER_LIMIT,
        offset: (Number(activeTimeline) - 1) * Number(USER_LIMIT)
      },
      skip: !organisationId || !teamId
    }),
    userTimelineData = _useQuery2.data,
    userTimelineError = _useQuery2.error,
    userTimelineLoading = _useQuery2.loading,
    refetch = _useQuery2.refetch;
  React.useEffect(function () {
    refetch === null || refetch === void 0 ? void 0 : refetch();
  }, [props.location.key]);
  var dateFilter = arrayToStringOutput([startDate, endDate], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone);

  //console.log("timelineChartData", timelineChartData);

  return /*#__PURE__*/React.createElement("div", {
    className: "employee-timeline-page-wrapper"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "timeline-header-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "timeline-header-section-date"
  }, dateFilter, " Activities"), /*#__PURE__*/React.createElement("div", {
    className: "timeline-header-section-show-text"
  }, /*#__PURE__*/React.createElement("div", {
    className: "timeline-header-section-show-text-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "timeline-header-section-show-text-circle-prod"
  }), /*#__PURE__*/React.createElement("div", {
    className: "timeline-header-section-show-text-letter"
  }, "Productive Apps Time")), /*#__PURE__*/React.createElement("div", {
    className: "timeline-header-section-show-text-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "timeline-header-section-show-text-circle-unprodu"
  }), /*#__PURE__*/React.createElement("div", {
    className: "timeline-header-section-show-text-letter"
  }, "Unproductive Apps Time")), /*#__PURE__*/React.createElement("div", {
    className: "timeline-header-section-show-text-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "timeline-header-section-show-text-circle-neutral"
  }), /*#__PURE__*/React.createElement("div", {
    className: "timeline-header-section-show-text-letter"
  }, "Neutral Apps Time")), /*#__PURE__*/React.createElement("div", {
    className: "timeline-header-section-show-text-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "timeline-header-section-show-text-circle-idle"
  }), /*#__PURE__*/React.createElement("div", {
    className: "timeline-header-section-show-text-letter"
  }, "Idle Time")), /*#__PURE__*/React.createElement("div", {
    className: "timeline-header-section-show-text-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "timeline-header-section-show-text-circle-break"
  }), /*#__PURE__*/React.createElement("div", {
    className: "timeline-header-section-show-text-letter"
  }, "Not In Work")), /*#__PURE__*/React.createElement("div", {
    className: "timeline-header-section-show-text-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "timeline-header-section-show-text-circle-untracked"
  }), /*#__PURE__*/React.createElement("div", {
    className: "timeline-header-section-show-text-letter"
  }, "Untracked")))), /*#__PURE__*/React.createElement("div", {
    className: "timeline-chart-data-root"
  }, /*#__PURE__*/React.createElement(EmployeeTimelineData, {
    userTimelineData: userTimelineData,
    dateFilter: dateFilter,
    userTimelineLoading: userTimelineLoading,
    userTimelineError: userTimelineError
  }))), userTimelineCountLoading ? /*#__PURE__*/React.createElement(Loader, null) : userTimelineCountData !== null && userTimelineCountData !== void 0 && userTimelineCountData.userTimelineCount && Math.ceil(Number(userTimelineCountData === null || userTimelineCountData === void 0 ? void 0 : userTimelineCountData.userTimelineCount) / USER_LIMIT) > 1 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "timeline-pagination-section-label"
  }, "Navigate to next section to see other members timeline"), /*#__PURE__*/React.createElement("div", {
    className: "timeline-pagination-section"
  }, /*#__PURE__*/React.createElement(Pagination, null, function () {
    var items = [];
    var _loop = function _loop(number) {
      items.push( /*#__PURE__*/React.createElement(Pagination.Item, {
        key: number,
        active: number === activeTimeline,
        onClick: function onClick() {
          setActiveTimeline(number);
        }
      }, number));
    };
    for (var number = 1; number <= Math.ceil(Number(userTimelineCountData === null || userTimelineCountData === void 0 ? void 0 : userTimelineCountData.userTimelineCount) / USER_LIMIT); number++) {
      _loop(number);
    }
    return items;
  }()))) : null);
};
var EmployeeTimelineData = function EmployeeTimelineData(props) {
  var userTimelineData = props.userTimelineData,
    dateFilter = props.dateFilter,
    userTimelineLoading = props.userTimelineLoading,
    userTimelineError = props.userTimelineError;
  if (userTimelineLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (userTimelineError) {
    return /*#__PURE__*/React.createElement("div", null, "Something went wrong, please refresh the page.");
  }
  if (!userTimelineData) {
    return null;
  }
  var timelineChartData = userTimelineData.userTimeline.reduce(function (acc, curr) {
    var displayName = curr.displayName,
      activity = curr.activity,
      activityStart = curr.activityStart,
      activityEnd = curr.activityEnd,
      totalHours = curr.totalHours,
      status = curr.status,
      tooltipStartTime = curr.tooltipStartTime,
      tooltipEndTime = curr.tooltipEndTime,
      isIdle = curr.isIdle,
      date = curr.date;

    // if (displayName == "Nandhini S" && isIdle) {
    //   console.log({ ...curr });
    // }

    if ((dateFilter === "This Month" || dateFilter === "Last Month") && totalHours > 0 || dateFilter !== "This Month" && dateFilter !== "Last Month") {
      // const startTimeFormat = moment.unix(Number(activityStart) / 1000).format("YYYY,M,D,HH,mm");

      var startTimeFormatSplit = activityStart.split(",");
      startTimeFormatSplit[1] = Number(startTimeFormatSplit[1] - 1);
      var startTime = new Date(startTimeFormatSplit[0], startTimeFormatSplit[1], startTimeFormatSplit[2], startTimeFormatSplit[3], startTimeFormatSplit[4]);

      // console.log("startTime",startTime);

      // const endTimeFormat = moment.unix(Number(activityEnd) / 1000).format("YYYY,M,D,HH,mm");

      var endTimeFormatSplit = activityEnd.split(",");
      endTimeFormatSplit[1] = Number(endTimeFormatSplit[1] - 1);
      var endTime = new Date(endTimeFormatSplit[0], endTimeFormatSplit[1], endTimeFormatSplit[2], endTimeFormatSplit[3], endTimeFormatSplit[4]);

      // When clocks go back (01:59 -> 01:00) the wall-clock end can read
      // earlier than the start. The chart rejects such a row and fails to
      // draw at all, so skip it.
      if (endTime < startTime) {
        return _toConsumableArray(acc);
      }
      return [].concat(_toConsumableArray(acc), [[displayName, activity, activity === "start" ? "stroke-color:#7454f5; stroke-width: 0.8; color:#7454f5;" : activity === "break" ? "stroke-color: #f1c40f; stroke-width: 0.8;color: #f1c40f;" : activity === "stop" ? "stroke-color: #e67e22; stroke-width: 0.8;color: #e67e22;" : activity === "untracked" ? "stroke-color:#CDC2AE; stroke-width: 0.8;color:#CDC2AE;" : isIdle ? "stroke-color:#E67E22; stroke-width: 0.8;color:#E67E22;" : status === "productive" ? "stroke-color:#27ae60; stroke-width: 0.8;color:#27ae60;" : status === "unproductive" ? "stroke-color: #c0392b; stroke-width: 0.8;color:#c0392b;" : "stroke-color:#40739e; stroke-width: 0.8;color:#40739e;", "<div class=\"apps-tootlip-timeline\">\n          <span class=\"apps-tootlip-timeline-title\"> ".concat(activity === "start" ? "Work Started" : activity === "break" ? "Not In Work" : activity === "stop" ? "Stopped Work" : activity === "untracked" ? "Untracked" : isIdle ? "Idle" : status.charAt(0).toUpperCase() + status.slice(1) + " App", " ").concat(activity === "start" || activity === "break" || activity === "stop" || activity === "untracked" ? "" : "(".concat(activity, ")"), "</span>\n          <br>\n          <span class=\"apps-tootlip-timeline-time\">").concat(displayName, " : </span><span class=\"timeline-time\">").concat(tooltipStartTime, " - ").concat(tooltipEndTime, "<span>\n          <br>\n          <span class=\"apps-tootlip-timeline-time\">Date : </span><span class=\"timeline-time\">").concat(date, "<span>\n  <br>\n          <span class=\"apps-tootlip-timeline-time\">Duration: </span><span class=\"timeline-time\">").concat(convertSecToHoursAndMinutesAndSecWithTextShortForm(Number(totalHours)), " </span>\n        </div>"),
      // moment.unix(Number(activityStart)/1000),
      // moment.unix(Number(activityEnd)/1000),
      startTime, endTime]]);
    } else {
      return _toConsumableArray(acc);
    }
  }, [[{
    type: "string",
    id: "Name"
  }, {
    type: "string",
    id: "Activity"
  }, {
    type: "string",
    role: "style"
  }, {
    role: "tooltip",
    type: "string"
  }, {
    type: "date",
    id: "Start"
  }, {
    type: "date",
    id: "End"
  }]]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, userTimelineData.userTimeline.length !== 0 ? /*#__PURE__*/React.createElement(Chart, {
    width: "100%",
    height: "71vh",
    chartType: "Timeline",
    loader: /*#__PURE__*/React.createElement(Loader, null)
    //error={<div>Something went wrong, please refresh the page.</div>}
    ,
    data: timelineChartData,
    options: {
      rowHeight: 100,
      timeline: {
        showBarLabels: false,
        barLabelStyle: {
          height: 500,
          fontSize: 25
        }
      },
      tooltip: {
        isHtml: true
      },
      avoidOverlappingGridLines: false
    },
    rootProps: {
      "data-testid": "3"
    }
  }) : /*#__PURE__*/React.createElement("div", {
    className: "timeline-no-data-found"
  }, "No data found!!!"));
};
export default EmployeeTimeline;